<div id="entity-selection" [formGroup]="configuration">
  <h3 class="basic-flex-container">
    {{ isNewConfig ? recordLabels.choose.title : recordLabels.chosen.title }}
    @if (!configuration.get('entity').valid) {
      <mat-icon
        class="error-circle"
        fontIcon="error_outline"
        [matTooltip]="recordLabels.choose.tooltip"
        matTooltipShowDelay="500"
      ></mat-icon>
    }
  </h3>
  @if (!loadingEntities) {
    <mat-button-toggle-group
      formControlName="entity"
      id="entity-selection-toggle"
      class="kyloe-large entity-selection-toggle"
      [hideSingleSelectionIndicator]="true"
      >
      @for (entity of entitiesToRender; track entity.objectName) {
        <mat-button-toggle
          value="{{ entity.objectName }}"
          [matTooltip]="entity.tooltip"
          matTooltipShowDelay="500"
          class="{{ entity.objectName | lowercase }}"
          [style.--entity-hover-color]="entity.hoverColor"
          >
          @if (entity.iconUrl) {
            <app-salesforce-entity-icon
              [entityType]="entity.objectName"
              [iconUrl]="entity.iconUrl"
              [iconColor]="entity.iconColor"
              imgClass="entity-icon-img brc-icon"
              [iconClass]="entity.iconClass">
            </app-salesforce-entity-icon>
          } @else {
            <i class="{{ entity.iconClass }}"></i>
          }
          {{ entity.label | uppercase }}
          @if (entity.iconUrl) {
            <app-salesforce-entity-icon
              [entityType]="entity.objectName"
              [iconUrl]="entity.iconUrl"
              [iconColor]="entity.iconColor"
              [iconClass]="entity.iconClass"
              [renderAsWatermark]="true"
              imgClass="brc-icon watermark dynamic-watermark">
            </app-salesforce-entity-icon>
          } @else {
            <i class="{{ entity.iconClass }} watermark"></i>
          }
        </mat-button-toggle>
      }
    </mat-button-toggle-group>
  }
</div>
@if (loadingEntities) {
  <app-skeleton
    [style]="'big-toggle-buttons'"
    [count]="7"
    [flex]="true"
    [gap]="20"
    [containerPadding]="0"
  ></app-skeleton>
}

<!--{{ configuration.value | json }}-->
